import { RootState } from '../../RootState';
import { StateCart } from '../CartsState';

const selectTotalQuantityCount = (state: RootState): number => {
  let totalQuantitiesCount: number = 0;

  Object.values(state.carts.carts).forEach((cart: StateCart | null) => {
    if (cart !== null) {
      totalQuantitiesCount += cart.totalQuantityCount;
    }
  });

  return totalQuantitiesCount;
};

export default selectTotalQuantityCount;
